<button
  type="button"
  mat-icon-button
  [matMenuTriggerFor]="infoMenu"
  matTooltip="Information anzeigen"
  [class.small-icon-button]="apperance() === 'small'"
>
  <mat-icon>info</mat-icon>
</button>

<mat-menu #infoMenu="matMenu" class="info-popover">
  <lib-info>
    <ng-content></ng-content>
  </lib-info>
</mat-menu>
